define("calendar/components/calendar/social-profiles", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "@ember/utils", "later/utils/compare-strings"], function (_exports, _component, _templateFactory, _component2, _object, _service, _utils, _compareStrings) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class2;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"later/utils/compare-strings",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section 
    class={{concat-classes
      "cCA--header"
      "o--page__header"
      "at--pirateOnboardingV2__socialProfilesRight"
      "at--accountConnectionTroubleshooting__socialProfileHeader"
      this.onboardingHeaderClass
    }}
    {{did-insert this.setSocialProfile}}
    data-test-id="calendar-social-profiles-header"
  >
    <div class="cCA--header__accountAction at--multiProfileExperiment__accountAction at--multiProfileChecklist__accountAction at--holisticOnboarding__accountAction at--pirateOnboardingV2__accountAction at--pirateOnboardingV2__socialProfilesLeft at--pirateOnboardingV2--introA__socialProfiles at--pirateOnboardingV2--introB__socialProfiles at--pirateOnboardingV2--introC__socialProfiles at--onboarding--connectProfileWithMediaV1__socialProfiles">
      <span class="cCA--account__title">
        {{t "calendar.header"}}
      </span>
      <div 
        class="cCA--header__account at--multiProfilePost__profileSwitcher at--multiProfileChecklist__profileSwitcher"
        {{perfect-scroll}}
      >
        {{!-- Social Profiles Added --}}
        {{#each (sort-by "id" this.socialProfiles) as |profile|}}
          <Calendar::SocialProfiles::Avatar
            @openTiktokRefreshModal={{@openTiktokRefreshModal}}
            @socialProfile={{profile}}
          />
        {{/each}}
  
        {{!-- Header Actions --}}
        {{#if this.isAccountOwner}}
          <Calendar::SocialProfiles::AvailableProfiles />
          {{#if this.hasSocialProfile}}
            <div class="cCA--account__item at--addProfile__addButton at--holisticOnboarding__addButton">
              <LinkTo
                @route="account.groups.group.social_profiles.new"
                @model={{this.currentGroup}}
                class="cCA--user o--user is--unselected"
                data-test-id="calendar-social-profiles-new-link"
                tabindex="0"
              >
                <img
                  class="o--user__avatar"
                  src="/assets/images/img--add--more.png"
                >
                <img
                  class="o--user__avatar"
                  src="/assets/images/img--add--more.png"
                >
              </LinkTo>
            </div>
          {{/if}}
        {{/if}}
      </div>
  
    </div>  
  
    <div class="o--page__cta cCA--page__cta {{if this.isFreeEligibleForTrial "at--calendarSocialProfiles__trialButton"}}" 
      {{did-insert this.trackNearPostLimitThreshold}}>
      {{!-- If there's an active trial, the TrialCountdown component is rendered here --}}
  
      {{#if this.rolloutSeamlessCheckout}}
        <Checkout::UpgradeButton @size="large" @showButton={{this.isFreeEligibleForTrial}} />
      {{else}}
        {{#unless this.hasActiveTrial}}
          <Calendar::SocialProfiles::RemainingPosts
            @canUpgrade={{this.isFree}}
            @getMorePostsThreshold={{this.GET_MORE_POSTS_THRESHOLD}}
          />
          {{#if (or this.isFree this.showNearPostLimitUpgradeButton)}}
            <Shared::Button::Upgrade
              @text={{t "shared_phrases.upgrade_plan"}}
              @size="large"
              @feature={{if this.isFree "trialPlansSnapshot" "plans"}}
              @location={{this.upgradeButtonEventLocation}}
              data-test-id="account-upgrade-button"
            />
          {{/if}}
        {{/unless}}
      {{/if}}
    </div>
  </section>
  
  */
  {
    "id": "ejmqf8F5",
    "block": "[[[11,\"section\"],[16,0,[28,[37,0],[\"cCA--header\",\"o--page__header\",\"at--pirateOnboardingV2__socialProfilesRight\",\"at--accountConnectionTroubleshooting__socialProfileHeader\",[30,0,[\"onboardingHeaderClass\"]]],null]],[24,\"data-test-id\",\"calendar-social-profiles-header\"],[4,[38,1],[[30,0,[\"setSocialProfile\"]]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"cCA--header__accountAction at--multiProfileExperiment__accountAction at--multiProfileChecklist__accountAction at--holisticOnboarding__accountAction at--pirateOnboardingV2__accountAction at--pirateOnboardingV2__socialProfilesLeft at--pirateOnboardingV2--introA__socialProfiles at--pirateOnboardingV2--introB__socialProfiles at--pirateOnboardingV2--introC__socialProfiles at--onboarding--connectProfileWithMediaV1__socialProfiles\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"cCA--account__title\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"calendar.header\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[11,0],[24,0,\"cCA--header__account at--multiProfilePost__profileSwitcher at--multiProfileChecklist__profileSwitcher\"],[4,[38,3],null,null],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[28,[37,6],[\"id\",[30,0,[\"socialProfiles\"]]],null]],null]],null],null,[[[1,\"        \"],[8,[39,7],null,[[\"@openTiktokRefreshModal\",\"@socialProfile\"],[[30,2],[30,1]]],null],[1,\"\\n\"]],[1]],null],[1,\"\\n\"],[41,[30,0,[\"isAccountOwner\"]],[[[1,\"        \"],[8,[39,9],null,null,null],[1,\"\\n\"],[41,[30,0,[\"hasSocialProfile\"]],[[[1,\"          \"],[10,0],[14,0,\"cCA--account__item at--addProfile__addButton at--holisticOnboarding__addButton\"],[12],[1,\"\\n            \"],[8,[39,10],[[24,0,\"cCA--user o--user is--unselected\"],[24,\"data-test-id\",\"calendar-social-profiles-new-link\"],[24,\"tabindex\",\"0\"]],[[\"@route\",\"@model\"],[\"account.groups.group.social_profiles.new\",[30,0,[\"currentGroup\"]]]],[[\"default\"],[[[[1,\"\\n              \"],[10,\"img\"],[14,0,\"o--user__avatar\"],[14,\"src\",\"/assets/images/img--add--more.png\"],[12],[13],[1,\"\\n              \"],[10,\"img\"],[14,0,\"o--user__avatar\"],[14,\"src\",\"/assets/images/img--add--more.png\"],[12],[13],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"    \"],[13],[1,\"\\n\\n  \"],[13],[1,\"  \\n\\n  \"],[11,0],[16,0,[29,[\"o--page__cta cCA--page__cta \",[52,[30,0,[\"isFreeEligibleForTrial\"]],\"at--calendarSocialProfiles__trialButton\"]]]],[4,[38,1],[[30,0,[\"trackNearPostLimitThreshold\"]]],null],[12],[1,\"\\n\"],[1,\"\\n\"],[41,[30,0,[\"rolloutSeamlessCheckout\"]],[[[1,\"      \"],[8,[39,11],null,[[\"@size\",\"@showButton\"],[\"large\",[30,0,[\"isFreeEligibleForTrial\"]]]],null],[1,\"\\n\"]],[]],[[[41,[51,[30,0,[\"hasActiveTrial\"]]],[[[1,\"        \"],[8,[39,13],null,[[\"@canUpgrade\",\"@getMorePostsThreshold\"],[[30,0,[\"isFree\"]],[30,0,[\"GET_MORE_POSTS_THRESHOLD\"]]]],null],[1,\"\\n\"],[41,[28,[37,14],[[30,0,[\"isFree\"]],[30,0,[\"showNearPostLimitUpgradeButton\"]]],null],[[[1,\"          \"],[8,[39,15],[[24,\"data-test-id\",\"account-upgrade-button\"]],[[\"@text\",\"@size\",\"@feature\",\"@location\"],[[28,[37,2],[\"shared_phrases.upgrade_plan\"],null],\"large\",[52,[30,0,[\"isFree\"]],\"trialPlansSnapshot\",\"plans\"],[30,0,[\"upgradeButtonEventLocation\"]]]],null],[1,\"\\n\"]],[]],null]],[]],null]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"profile\",\"@openTiktokRefreshModal\"],false,[\"concat-classes\",\"did-insert\",\"t\",\"perfect-scroll\",\"each\",\"-track-array\",\"sort-by\",\"calendar/social-profiles/avatar\",\"if\",\"calendar/social-profiles/available-profiles\",\"link-to\",\"checkout/upgrade-button\",\"unless\",\"calendar/social-profiles/remaining-posts\",\"or\",\"shared/button/upgrade\"]]",
    "moduleName": "calendar/components/calendar/social-profiles.hbs",
    "isStrictMode": false
  });

  let SocialProfilesComponent = (_class = (_class2 = class SocialProfilesComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "onboarding", _descriptor2, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);

      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor4, this);

      _initializerDefineProperty(this, "segment", _descriptor5, this);

      _defineProperty(this, "GET_MORE_POSTS_THRESHOLD", 3);
    }

    get hasActiveTrial() {
      return this.currentAccount.hasActiveTrial;
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get isFree() {
      return !this.currentAccount.hasActiveSubscription;
    }

    get isFreeEligibleForTrial() {
      var _this$auth$currentAcc;

      return !this.currentAccount.hasActiveSubscription && ((_this$auth$currentAcc = this.auth.currentAccount) === null || _this$auth$currentAcc === void 0 ? void 0 : _this$auth$currentAcc.canTrialPlan);
    }

    get currentGroup() {
      return this.auth.currentGroup;
    }

    get isAccountOwner() {
      return this.auth.currentUserModel.isAccountOwner;
    }

    get socialProfiles() {
      return this.currentGroup.socialProfiles;
    }

    get hasSocialProfile() {
      return (0, _utils.isPresent)(this.auth.currentGroup.socialProfiles);
    }

    get onboardingHeaderClass() {
      const {
        onBeginOnboardingStep,
        hasNotCompletedOnboarding
      } = this.onboarding;
      const isBeginningOnboarding = onBeginOnboardingStep && hasNotCompletedOnboarding;
      return isBeginningOnboarding && this.hasSocialProfile ? 'cCA--header--dark' : '';
    }

    get isNearPostLimitUpgradeABTestVariant() {
      var _this$auth$currentAcc2, _this$auth$currentAcc3;

      return (0, _compareStrings.areStringsEqual)((_this$auth$currentAcc2 = this.auth.currentAccount) === null || _this$auth$currentAcc2 === void 0 ? void 0 : (_this$auth$currentAcc3 = _this$auth$currentAcc2.experiments) === null || _this$auth$currentAcc3 === void 0 ? void 0 : _this$auth$currentAcc3['web_near-post-limit_main-cta-upgrade'], 'upgrade-button') && (this.subscriptions.subscriptionPlan.hasLimitedPosts || this.isFree);
    } // NOTE: AB test will be linked to rollout flag on back-end initially.


    get rolloutSeamlessCheckout() {
      return this.currentAccount.rolloutSeamlessCheckout;
    }

    get showNearPostLimitUpgradeButton() {
      if (!this.isNearPostLimitUpgradeABTestVariant) {
        return false;
      }

      return this.hasHitPostLimitThreshold(SocialProfilesComponent.NEAR_POST_LIMIT);
    }

    get upgradeButtonEventLocation() {
      if (this.showNearPostLimitUpgradeButton && this.selectedSocialProfiles.profiles.some(profile => profile.hasLimitedPosts)) {
        return 'posts remaining';
      }

      return 'navigation bar';
    }

    setSocialProfile() {
      this.auth.setSocialProfile(this.selectedSocialProfiles.firstProfile);
    }

    trackNearPostLimitThreshold() {
      if (this.hasHitPostLimitThreshold(SocialProfilesComponent.NEAR_POST_LIMIT)) {
        this.segment.track('web_near-post-limit_main-cta-upgrade');
      }

      if (this.hasHitPostLimitThreshold(this.GET_MORE_POSTS_THRESHOLD)) {
        this.segment.track('web_near-post-limit_get-more-posts');
      }
    }

    hasHitPostLimitThreshold(threshold) {
      return this.socialProfiles.filter(profile => profile.hasLimitedPosts).some(profile => profile.postsLeft <= threshold);
    }

  }, _defineProperty(_class2, "NEAR_POST_LIMIT", 10), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "setSocialProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSocialProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackNearPostLimitThreshold", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackNearPostLimitThreshold"), _class.prototype)), _class);
  _exports.default = SocialProfilesComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SocialProfilesComponent);
});